<template>
  <div class="wrapper col-8">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">

        <!-- HEADER -->
        <div slot="header">
          <i class="fa fa-bell-o"></i> Temporary Venue
          <div class="card-header-actions">
                <b-button type="button" size="sm" variant="primary" @click="mofaEventHandler"> <!-- :disabled="isNew" -->
                  <i class="fa fa-edit"></i> MoFA
                </b-button>
          </div>
        </div>
        <!-- // HEADER -->

        <!-- FORM -->
        <b-form id="temp">
          <b-container>
              <b-row>
                <b-col>
                  <h5>1. Purpose of the Mission<span class="required">*</span></h5>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="col-4">
                  <b-form-group class="required">
                    <b-form-select 
                       v-if="purposeList"
                       type="text" placeholder="Mission Purpose" 
                       text-field="description" 
                       value-field="id"
                       :options="purposeList"
                       :value="purposeId"
                       @change="purposeChangeEventHandler">
                       <template slot="first">
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                    </b-form-select>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('purposeId') }}</small>
                  </b-form-group>
                </b-col>

                <b-col class="col-4" v-if="isOtherPurpose">
                  <b-form-group class="required">
                      <b-form-input ref="purposeOthers" v-model="purposeOthers" placeholder="Enter other purpose" @keyup.native="changeEventHandler"></b-form-input></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('purposeOthers') }}</small>
                  </b-form-group>  
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col>
                    <h5>1.1 Venue Details</h5>
                </b-col>
              </b-row>

              <b-row>
                 <b-col class="col-12">
                    <small class="text-danger font-weight-bold">{{ validation.firstError('venues') }}</small>
                 </b-col>
              </b-row>

              <b-row>  
                <b-col>
                  <table class="table table-bordered table-hover table-md table-sm table-xs">
                    <thead class="col-12">
                      <th class="no-border-right">
                        <div class="float-left">
                          <input type="checkbox" class="select-row" @click="selectAllVenueEventHandler" title="Select All" v-model="checked_all"> &nbsp;
                          <b-button type="button" :disabled="deleteCounter === 0" class="btn btn-secondary btn-sm" title="Delete" @click="deleteEventHandler"><i class="fa fa-trash-o"></i></b-button>
                        </div>
                      </th>
                      <th scope="col" class="center">City</th>                      
                      <th scope="col" class="center">Venue Name</th>
                      <th scope="col" class="center">GPS Coordinates</th>
                      <th scope="col" class="center">Date From</th>
                      <th scope="col" class="center">Date To</th>
                    </thead>
                    <tr v-if="venues.length === 0">
                      <th width="70px" class="no-border-right">
                        <div class="float-left"></div>
                      </th>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">&nbsp;</th>
                    </tr>
                    <tr v-if="venues" v-for="(v, index) in venues" :key="v.id">
                        <td width="70px">
                          <div class="float-left">
                            <input type="checkbox" class="select-row" v-model="selected_venue[index]" @click="selectedVenueEventHandler">  &nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="initVenueModal(index)" v-b-modal.venue><i class="fa fa-pencil"></i></button>
                            <!-- <b-button v-if="selected_venue || checked_all" type="button" class="btn btn-secondary btn-sm" @click="deleteEventHandler(index)"><i class="fa fa-trash-o"></i> Delete</b-button> -->
                          </div>
                        </td>
                        <td> {{ v.city }} </td>
                        <td> {{ v.venue_name }} </td>
                        <td> {{ v.gps }} </td>
                        <td> {{ v.date_from | formatDate('DD/MM/YYYY HH:mm') }} </td>
                        <td> {{ v.date_to  | formatDate('DD/MM/YYYY HH:mm') }} </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-button size="sm" variant="secondary" @click="searchMapEventHandler('add')"><i class="fa fa-map-o"></i> Add Venue</b-button>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col>
                    <h5>2. Location / Venue</h5>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <div class="thumbnail emptyImage col-12">                    
                    <!-- <div class="card-columns"> 
                        <b-card-group deck>                     
                          <div>
                            <b-card no-body v-for="(v, index) in venues" :key="v.id" v-if="venues"
                                :img-src="v.static_map"
                                img-alt="Image"
                                img-top
                                style="max-width: 12rem">
                                <p class="text-muted small mt-2">{{v.city}}</p>                                
                            </b-card>
                          </div>
                        </b-card-group>
                      </div> -->

                      <div class="card-columns">
                          <div class="card" v-for="(v, index) in venues" :key="v.id" v-if="venues">
                              <img class="card-img-top img-fluid" :src="v.static_map" :alt="v.gps">
                              <p class="card-text">{{v.city}}</p>
                          </div>                          
                      </div>
                  </div>
                </b-col>
              </b-row>
              
             <!--  <hr>

              <b-row>
                <b-col>
                    <h5>3. Upload Documents</h5>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="7"> 
                    <b-alert :show="showUploadAlert"
                             dismissible
                             variant="warning">
                        <strong>Upload completed!</strong> You successfully upload the file.
                    </b-alert>
                    <b-alert :show="showUploadError"
                           dismissible
                           variant="danger">
                        <strong>Upload Error!</strong> File size must not exceed 1MB in size.
                    </b-alert>
                    <b-form-group>
                       <file-upload
                            ref='fileUpload'
                            title=""
                            accept=".xlsx, .xls, .pdf"
                            @event-handler="fileUploadEventHandler($event)">            
                          </file-upload> 
                    </b-form-group>
                </b-col> -->
                
                <!-- <b-col sm="5"> 
                    <b-form-group>
                      <label>Upload the following documents:</label>
                       <ul>
                        <li>Pax Manifest</li>
                        <li>Passport copies and Visa copies</li>
                        <li>Cargo documents</li>
                        <li>Packing lists</li>
                        <li>Any other documents</li>                      
                       </ul>
                    </b-form-group>
                </b-col> -->
              <!-- </b-row> -->

             <!--  <b-row>
                <b-col>
                    <b-table style="background-color: #fff" hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" :items="attachments" :fields="fields" :current-page="currentPage" :per-page="perPage">
                       <template slot="date_uploaded" slot-scope="data">
                        {{data.item.date_uploaded | formatDate('DD/MM/YYYY HH:mm:ss')}} 
                      </template>
                      <template slot="action" slot-scope="data" style="width:10px">
                          <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                            <template slot="button-content">
                              <i class="icon-settings"></i>
                            </template>
                            <b-dropdown-item @click="uploadItemEventHandler(data.item)" v-b-modal.confirmAttachmentModal v-b-modal.modal-center> Delete</b-dropdown-item>
                            <b-dropdown-item @click="downloadEventHandler(data.item)"> Download</b-dropdown-item>                            
                          </b-dropdown>                
                      </template>
                    </b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <nav> 
                    <b-pagination size="sm" :total-rows="getRowCount(attachments)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"/>
                  </nav> 
                </b-col> 
              </b-row> -->

           </b-container> 
        </b-form>
        <!--// FORM -->



        <!-- FOOTER -->  
        <div slot="footer" class="float-right">
            <b-button variant="primary" @click="submitEventHandler" :disabled="!modified"><i class="fa fa-save"></i> Save</b-button>&nbsp;
            <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> Close</b-button>
        </div>
        <!--// FOOTER -->  

      </b-card>
    </div>

    <!--// MODAL Confirm Save -->   
     <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal" id="confirmSaveModal" @ok="submitEventHandler" @cancel="close" ok-title="Save, save changes" cancel-title="Cancel, leave changes" centered>
        <p class="my-4">You have unsaved changes on this form.  If you leave, your changes will be lost.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>     
    </b-modal>  
    <!--// MODAL Confirm Save -->  

    <!--// MODAL Confirm Save -->   
     <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal2" id="confirmSaveModal2Mofa" @ok="submitEventHandler" @cancel="close" ok-title="Save, save changes" cancel-title="Cancel, leave changes" centered>
        <p class="my-4">You have unsaved changes on this form.  If you leave, your changes will be lost.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>
    </b-modal>  
    <!--// MODAL Confirm Save -->  

     <!-- MODAL Venue -->
    <b-modal centered id="venue" size="lg" ref="venueModal" title="Venue Details" class="modal-primary" ok-title="Add" @ok="submitModalEventHandler">
      <b-row>
        <b-col sm="12">
             <b-form>
              <b-row>
                <b-col sm="8">
                  <b-form-group class="required">
                      <label>City</label>
                      <b-form-input type="text" v-model="venue.city" placeholder="Enter city" @keyup.native="changeEventHandler"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('venue.city') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group description="Latitude, Longitude" class="required">
                      <label>GPS Coordinates</label>
                      <b-input-group>
                        <b-form-input readonly type="text" v-model="venue.gps" placeholder="Enter GPS coordinates"></b-form-input>
                        <b-input-group-append>
                           <b-button variant="secondary" @click="searchMapEventHandler('gps')"><i class="fa fa-map-marker"></i></b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('venue.gps') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>  
              <b-row>
                <b-col sm="8">
                  <b-form-group class="required">
                      <label>Venue Name</label>
                      <b-form-input type="text" v-model="venue.venue_name" placeholder="Enter venue name" @keyup.native="changeEventHandler"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('venue.venue_name') }}</small>
                  </b-form-group>
                </b-col>                 
              </b-row>
              <b-row>
                <b-col sm="4">                              
                  <b-form-group class="required">
                    <label>Date From</label><br>
                    <datepicker format="DD/MM/YYYY HH:mm:ss" v-model="venue.date_from" :local="local" :disabled-date="disabledDate" @input="dateFromChangeEventHandler"/><br>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('venue.date_from') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group class="required">
                    <label>Date To</label><br>
                    <datepicker format="DD/MM/YYYY HH:mm:ss" v-model="venue.date_to" :local="local" :disabled-date="disabledDateTo" @input="changeEventHandler"/><br>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('venue.date_to') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                 
                </b-col> 
              </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <!--// MODAL Venue -->

    <!--// MODAL Confirm Remove Attachment -->   
     <b-modal title="Confirm" class="modal-primary" id="confirmAttachmentModal" @ok="removeAttachmentEventHandler" ok-title="Yes" cancel-title="No" centered>
        <p class="my-4">Are you sure you want to remove this attachment?</p>     
    </b-modal>  
    <!--// MODAL Confirm Remove Attachment -->  

    <!--// MODAL MoFA -->   
    <b-modal title="Success" class="modal-primary" ref="confirmMofaModal" id="confirmMofaModal" @ok="mofaEventHandler" @cancel="close" ok-title="Next" cancel-title="Cancel" centered>
      <b-row>
        <b-col sm="2" class="text-center"><i class="fa fa-check-circle fa-3x text-success"></i> </b-col>
        <b-col sm="10"><p>You've successfully completed notification form.  Click <b>Next</b> to continue filling out MoFA form.</p>     </b-col>
      </b-row>        
    </b-modal>  
    <!--// MODAL MoFA -->


    <!-- <b-modal hide-footer id="venue" ref="venue" title="Venue Details">
      <b-form>
        <b-row class="col-md-12 col-xs-12 col-sm-12">
          <b-col class="col-md-8 col-xs-12 col-sm-12">
            <label class="mt-2">City</label>
              <b-form-input type="text" placeholder="Enter city" v-model="venue.city"></b-form-input>
              <div class="alert alert-danger mt-2"  v-if="isRequired">City is required</div>
          </b-col>
        </b-row>
        <b-row class="col-md-12 col-xs-12 col-sm-12">
          <b-col class="col-md-8 col-xs-12 col-sm-12">
            <label class="mt-2">Venue Name</label>
            <b-form-input  v-model="venue.venue_name" type="text" placeholder="Enter Venue Name"> </b-form-input>
            <div class="alert alert-danger mt-2" v-if="isRequired">Venue name is required</div>
          </b-col>
        </b-row>
        <b-row class="col-md-12 col-xs-12 col-sm-12">
          <label class="col-md-12 col-xs-12 col-sm-12 mt-2"> GPS Coordinates</label>
          <b-col class="col-md-8 col-xs-12 col-sm-12">
            <b-form-input v-model="venue.gps" type="text" class="mb-2"></b-form-input>
            <div class="alert alert-danger mt-2" v-if="isRequired">GPS is required</div>
          </b-col>
        </b-row>

        <b-row class="col-md-12 col-xs-12 col-sm-12">
          <b-col sm="6">
            <label>From</label>
            <datepicker format="DD/MM/YYYY" v-model="venue.date_from" :local="local" :disabled-date="disabledDate"  @change="changeNotificationFlag"/>            
          </b-col>
          <b-col sm="6">
            <label>To</label>
            <datepicker format="DD/MM/YYYY" v-model="venue.date_to" :local="local" :disabled-date="disabledDate"  @change="changeNotificationFlag"/>
          </b-col>
        </b-row>
        <br>
        <b-col>
          <div slot="footer" class="modal-footer">
          <b-button size="md" variant="primary" class="float-right modal-default-button" @click="validationModals"><div v-if="isEdit">Confirm changes</div><div v-if="!isEdit">Add</div></b-button>
          <b-button size="md" variant="secondary" class="float-right modal-default-button" @click="closeModal">Cancel</b-button>

        </div>
        </b-col>
      </b-form>
    </b-modal> -->
  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import * as types from '@/store/types'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import CommonService from '@/api/CommonService'
import TempVenueService from '@/api/TempVenueService'
import NotificationService from '@/api/NotificationService'
import UploadService from '@/api/UploadService'

import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'
import tempMixin from '@/mixins/validators/Temp-validators'

export default {
  data () {
    return {
      ctr: 0,
      isSuccess: false,
      isOtherPurpose: false,
      requestTypeId: 6,
      checked_all: false,
      selected_venue: [],
      isOther: false,
      tabIndex: 0,
      isEdit: false,
      recID: -1,
      venue: {},
      isRequired: false,
      show: true,
      deleteCounter: 0,
      showUploadAlert: false,
      showUploadError: false,
      isUploadReady: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      selectedAttachment: null,
      fields: [
        {label:'Id', key: 'id', sortable: true, class: 'sm="4"'},
        {label:'Upload Date', key: 'date_uploaded', sortable: true},
        {label:'Description', key: 'description', sortable: true},
        {label:'Filename', key: 'filename', sortable: true},        
        {key: 'action'}
      ],      
      local: constants.DATE_LOCALE_EN
    }
  },
  mixins: [
      tempMixin
  ],
  mounted() {

    this.$nextTick(function () {      
      setTimeout(function () {
         if (this.$store.state.purposeId === constants.PURPOSE_OTHERS) {
            this.isOtherPurpose = true            
         }
      }.bind(this), 600)
      
    })
    
  },
  created() {
      this.$store.dispatch(types.ACTION_FIND_PURPOSES, constants.FORM_TEMP_VENUE)

      const $this = this
      setTimeout(function () {
          
           // get attachments
          if ($this.notificationId) {
             TempVenueService.fetchAttachment($this.notificationId).then( (resp) => {
                $this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
              })          
          }          
      }.bind(this), 600)  

      // this.$store.commit(types.MUTATE_MAP_INDEX, 0)    
      setTimeout(function () {
          
          let row = $this.$store.state.map_index
           // get attachments
          if (row > 0) {

              // show venue diaglog
              $this.initVenueModal(row)
              $this.$refs.venueModal.show()
          }          
      }.bind(this), 600)   
    
  },
  computed: {

    purposeOthers: {
        get() {
          return this.$store.state.purposeOthers
        },
        set(value) {
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, value)
        }
    },
    isNew() {
      return this.$store.state.new_notification;
    },
  ...mapGetters({      
      venues: types.GET_VENUES,
      purposeId: types.GET_PURPOSE_ID,            
      purposeList: types.GET_PURPOSES,
      agencyList: types.GET_AGENCIES,
      requestTypeList: types.GET_REQUEST_TYPES,
      modified: types.GET_MODIFIED,
      mofaView: types.GET_VIEW_MOFA,
      attachments: types.GET_ATTACHMENTS,
      startDate: types.GET_START_DATE
    })
  },
  methods: {

    mofaEventHandler() {

       const routeName = utils.findMofaNameById( this.$store.state.requestTypeId )
       const notificationId = this.$store.state.notificationId

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:notificationId})
            this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        }.bind(this), 600)
       
       // load MOFA form       
       this.$router.replace('/forms/'+ routeName +"-mofa")       
    },

    dateFromChangeEventHandler() {
       this.$store.commit(types.MUTATE_MODIFIED, true)  
       // this.venue.date_to = this.venue.date_from       
    },

    disabledDateTo(time) {  
      let temp = this.$moment(this.venue.date_from, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DDTHH:mm:ss")
      let _fromDate = this.$moment(temp)
      return time < this.$moment(_fromDate).toDate()            
    },

    disabledDate (time) {
      let temp = this.$moment(this.$store.state.start_date, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DDTHH:mm:ss")
      let dStartDate = this.$moment(temp)
      return time < dStartDate.toDate()
    },

    // disabledDate (time) {
    //   let startDate = new Date(this.startDate)      
    //   startDate.setDate(startDate.getDate()-1);
    //   return time < startDate
    // },

    uploadItemEventHandler(item) {        
        this.selectedAttachment = item
    },

    downloadEventHandler(item) {
        CommonService.download(item).then( (resp) => {          
          
      })
    },

    removeAttachmentEventHandler() {
      let item = this.selectedAttachment;
      const payload = {
            id : item.id,
            notification_id: item.notification_id
        }

        UploadService.remove(payload).then( (response) => {
           this.$store.commit(types.MUTATE_ATTACHMENTS, response)
        })        
    },

    getRowCount (items) {
      return items.length
    },

     async fileUploadEventHandler(event) {

      const notificationId = this.$store.state.notificationId
      const requestTypeId = this.$store.state.requestTypeId
      const category = "TEMP_VENUE_DOCUMENT"
      const $this = this
      this.showUploadError = false
      
      let file = event.file
      if (!file) return

      // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      await UploadService.upload(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp.length > 0) {
              this.isUploadReady = true 
              setTimeout(function () {
                  this.showUploadAlert = false
                  this.$refs.fileUpload.reset()
              }.bind(this), 3000)

              // get attachments
              CommonService.fetchAttachment(notificationId).then( (resp) => {
                this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
              })
          }          
      })
    },

    submitEventHandler (e) {
      const $target = e.target.id
      const $this = this
      const fieldsMain = ['purposeId','purposeOthers','venues']
      
      this.$validate(fieldsMain)          
          .then(function(success) {
                $this.isSuccess = success

                if (success) {
                    $this.isSuccess = true
                    let currentDate = $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ')
                    let payload = {
                        id: $this.$store.state.notificationId,
                        agency_id: $this.$store.state.agencyId,
                        requested_date: currentDate,
                        request_type_id: constants.FORM_TEMP_VENUE,
                        requested_by: $this.$store.state.userId,
                        purpose_id:  $this.purposeId,
                        purpose_others:  $this.purposeOthers,
                        ehoc_ref: $this.$store.state.ehocRef,
                        notes: $this.$store.state.notes,
                        last_updated_by: $this.$store.state.userId,
                        last_update: currentDate,
                        status_id: constants.STATUS_INUSE
                      }

                       if ($this.$store.state.permission === constants.ADMIN) { 
                           payload.status_id = $this.$store.state.statusId
                       }
                      
                      if (payload.id == 0) {
                         // $this.$store.dispatch(types.ACTION_ADD_VENUES, payload)
                         // alert("SAVE New Record")
                      } 
                      else {

                          const notificationId = $this.$store.state.notificationId  
                          // UPDATE Notification
                          NotificationService.updateNotification(payload).then( (response) => {

                              if (response) {
                                  // UPDATE Venues
                                 $this.saveVenues(notificationId)
                                 $this.$store.commit(types.MUTATE_MODIFIED, false)      
                                 $this.$store.commit(types.MUTATE_NEW_NOTIFICATION, false)  

                                 toast.success( "Saved successfully")

                                 if ($this.$store.state.new_notification) {
                                      setTimeout(function () {
                                         $this.$refs.confirmMofaModal.show()
                                      }.bind(this), 300)
                                 }
                                 else if ($target === 'confirmSaveModal2Mofa') {
                                        $this.mofaEventHandler() 
                                 }
                              }                               
                          })
                      }                      
                }
                else {
                    toast.error( "Please complete all required fields", "Error")
                }
      })
    },

    confirmSaveEventHandler(e) {
      this.submitEventHandler()

      alert(this.isSuccess)

      if (this.isSuccess) {
          setTimeout(function () {

                if (e.target.id === 'confirmSaveModal2Mofa') {
                    this.mofaEventHandler()
                }
                else {
                    this.close()
                }
          }.bind(this), 300)
      }
    },

    changeEventHandler() {
      this.$store.commit(types.MUTATE_MODIFIED, true)
    },

    selectedVenueEventHandler(e) {

      if (e.target.checked) {
         this.deleteCounter++
      }
      else {
        this.deleteCounter--
      }

      if (this.checked_all) {
          this.checked_all = (this.deleteCounter > 0)
      }
    },

    selectAllVenueEventHandler (e) {
      this.selected_venue = [];

      for (let id in this.venues) {
        this.selected_venue.push( e.target.checked )
		  }

      if (e.target.checked) 
        this.deleteCounter = this.venues.length
      else 
        this.deleteCounter = 0
			
    },
    deleteAllModalItems () {
        for (var i = this.selected_venue.length -1; i >= 0; i--) {
          this.$store.state.temp_venue.venues.splice(this.selected_venue[i],1)
          this.$store.commit(types.MUTATE_VENUES, this.$store.state.temp_venue.venues)
        }
    },
    
    // linkClass (idx) {
    //   if (this.tabIndex === idx) {
    //     return ['bg-primary', 'text-white']
    //   } else {
    //     return ['bg-light', 'text-muted']
    //   }
    // },
    searchMapEventHandler(param) {

      console.log("param: "+ param)
      if (param === 'add') {
          this.$store.commit(types.MUTATE_MAP_INDEX, 0)
      }

      this.$router.replace({path:'/map-search', query: {param:'temp-venue'} })      
    },
    // getSelectedItem (e) {
    //   this.isOther = (e === 30)
    //   this.$store.commit(types.MUTATE_PURPOSE_ID, e)
    // },

    closeEventHandler () {
      if (this.modified) {
          this.$refs.confirmSaveModal.show()
      } 
      else {
          this.close()
      }
    },
    close() {
        this.$store.commit(types.MUTATE_RESET_STATE)
        this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        if (this.$store.state.permission === constants.ADMIN) {
            this.$router.replace('/dashboard')
        }    
        else {
            this.$router.replace('/user-dashboard')
        }      
    },

    submitModalEventHandler(e) {
      e.preventDefault()      

      this.$store.commit(types.MUTATE_MAP_INDEX, 0)

      const fieldsVenueModal = ['venue.city','venue.venue_name','venue.gps','venue.date_from','venue.date_to']
      const id = e.target.id
      const $this = this

      if (id === "venue") {
          this.$validate(fieldsVenueModal)
            .then(function(success) {
              if (success) {
                  //$this.commitRecord(id)
                  $this.$refs.venueModal.hide()                  
              }
            })
      }    
    },  

    // resetValidation () {
    //   this.venue = { city:'', venue_name:'', gps:'', date_from: '', date_to:'' }
    //   this.validation.reset()
    // },

    // closeEventHandler () {
    //   this.$store.commit(types.MUTATE_RESET_STATE)
    //   if (this.$store.state.permission === constants.ADMIN) {
    //       this.$router.replace('/dashboard')
    //   }    
    //   else {
    //       this.$router.replace('/user-dashboard')
    //   }  
    // },
    // closeModal () {
    //   this.$refs.venue.hide()
    //   this.venue = { city:'', venue_name:'', gps:'', date_from: '', date_to:'' }
    //   this.isEdit = false
    //   this.isRequired = false
    // },
    // validationModals () {      
    //   this.submitModals()
    // },
    submitModals () {
      let cTemp = []
      cTemp =  this.$store.state.temp_venue.venues
      //if (!this.$v.venue.city.$invalid && !this.$v.venue.venue_name.$invalid && !this.$v.venue.gps.$invalid) {
       if (!this.isEdit) {
        cTemp.push(this._data.venue)
        this.$store.commit(types.MUTATE_VENUES, cTemp)
        this.venue = { city:'', venue_name:'', gps:'', date_from: '', date_to:'' }
        }
        else {
          this.$store.state.temp_venue.venues[this.recID] = this._data.venue
          this.$store.commit(types.MUTATE_VENUES, cTemp)
          this.modified.venues = true
        }
          this.isRequired = false
      // }
      // else {
      //   this.isRequired = true
      // }
      this.closeModal()
    },
    async saveVenues(id) {
      let payload = this.$store.state.temp_venue.venues

      for (var obj of payload) {
          obj.notification_id = id
      }
      await TempVenueService.addVenues(payload).then( (response) => {            
      })
    },
    // async save () {
    //   let payload = { 
    //     agency_id: this.$store.state.agencyId,
    //     purpose_id :  this.selectedPurposeId,        
    //     purpose_others :  this.$store.state.purposeOthers,
    //     route_map_terrain : this.$store.state.map.roadmap,
    //     route_map_satellite : this.$store.state.map.satellite,
    //     ehoc_ref : this.$store.state.ehocRef,        
    //     notes: this.$store.state.notes
    //   }
    //   if (this.mode === constants.MODE_EDIT) {
    //       const notificationId = this.$store.state.notificationId
    //       payload.id = notificationId
    //       payload.request_type_id = this.$store.state.requestTypeId
    //       payload.requested_by = this.$store.state.requestedBy
    //       payload.last_updated_by = this.$store.state.userId
    //       payload.last_updated_by = this.$store.state.userId
    //       payload.notes = this.$store.state.notes
    //       payload.status_id = this.$store.state.statusId
          
    //       let ctr = 0;
    //       if (this.modified.notification) {
    //         await NotificationService.updateNotification(payload).then( (response) => {
    //           ctr++
    //         })
    //       }  
    //       if (this.modified.venues) {
    //           ctr++
    //       }
    //       this.saveVenues(notificationId)
    //       // show save message
    //       if (ctr > 0) {
    //         toast.success( "Saved successfully")
    //       }
    //   }
    //   else if (this.mode === constants.MODE_NEW) {
    //       // save notification
    //       payload.request_type_id = constants.FORM_TEMP_VENUE
    //       payload.requested_by = this.$store.state.userId
    //       payload.last_updated_by = this.$store.state.userId
    //       payload.status_id = constants.STATUS_ACKNOWLEDGED

    //       await NotificationService.addNotification(payload).then( (response) => {
    //         const notificationId = response.id; 
    //         // store notification into state
    //         this.$store.commit(types.MUTATE_MODE, constants.MODE_EDIT)
    //         this.$store.commit(types.MUTATE_NOTIFICATION_ID, notificationId)
    //         this.saveVenues(notificationId)
            
    //         toast.success( "Saved successfully")  
    //       })
    //   }      
    // },
    // getFormVals (e) {
    //   e.preventDefault()
    //   this.$store.commit(types.MUTATE_PURPOSE_OTHERS, this._data.otherPurposes)
    //   this.save ()
    // },
    initVenueModal (index) {
      this.isEdit = true
      this.recID = index
      this.venue = this.$store.state.temp_venue.venues[index]
      this.$store.commit(types.MUTATE_MAP_INDEX, index)
    },

    deleteEventHandler (e) {
      for (var id in this.selected_venue) {
           if (this.selected_venue[id]) {
               this.$delete(this.$store.state.temp_venue.venues, id)
           }
      }

      this.$store.commit(types.MUTATE_MODIFIED, true)
    },

    attachEventHandler(files) {
      if (!files.length) return
      let formData = new FormData();  
      Array.from(Array(files.length).keys())
       .map(i => {
        //alert(files[i].name)
          formData.append('file', files[i], files[i].name);
        });
    },
    purposeChangeEventHandler (e) {
      this.isOtherPurpose = (e === constants.PURPOSE_OTHERS)
       
      if (this.isOtherPurpose) {
          setTimeout(function () {
                    this.$refs.purposeOthers.$el.focus()
                  }.bind(this), 300) 
      } else {
        this.$store.commit(types.MUTATE_PURPOSE_OTHERS, "")
      }
      this.$store.commit(types.MUTATE_PURPOSE_ID, e)
      this.$store.commit(types.MUTATE_MODIFIED, true)      
    }, 

    mofaEventHandler() {

      if (!this.modified) {
          const routeName = utils.findMofaNameById( this.$store.state.requestTypeId )
          const notificationId = this.$store.state.notificationId

          setTimeout(function () {
                  this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:notificationId})
                  this.$store.commit(types.MUTATE_VIEW_MOFA, false)
              }.bind(this), 600)
           
          // load MOFA form       
          this.$router.replace('/forms/'+ routeName +"-mofa")       
      }
      else {

          this.$refs.confirmSaveModal2.show()

      }
    },
    changeNotificationFlag (e) {
      this.modified.notification = true
    }
  },
  components: {
    FileUpload
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

h5 {
  color: #373767;
}
.emptyImage {
    min-height: 200px;
    display: inline-block;
    border: #c8ced3 solid 1px;
    background: #f5f5f5;
    text-align: center;
    padding: 20px;    
}

.form-group.required label::after {
   margin-right: 2px;
   content:"*";
   color:red;
}
span.required {
  color:red; 
}
/*    width: 100%;*/

/*.card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.1rem;
}*/

/*@media (min-width: 576px)
.card-columns {     
    -webkit-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
 }   
*/
 @media (min-width:576px) {
      .card-columns {
        column-count: 2;
      }
  }
    @media (min-width:768px) {
      .card-columns {
        column-count: 3;
      }
  }
  @media (min-width:992px) {
      .card-columns {
        column-count: 4;
      }
  }
  @media (min-width:1200px) {
      .card-columns {
        column-count: 5;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/forms/TempVenue.vue